import { MenuList } from '@coursera/cds-core';

export default MenuList.Group;
